export default __webpack_public_path__ + "static/hero-3504c683f2ed88f2dfb97bf58b6d6a95.jpg";